import React from 'react';

import {
  AppSettingsTabPaneDocument,
  useAppSettingsTabPaneQuery,
  useToggleAllAccessMutation
} from 'generated/graphql';



export interface IData {
  allAccessEnabled: boolean;
}

export function useQuery() {
  const tuple = useAppSettingsTabPaneQuery({});

  return React.useMemo(
    () => {
      const data: IData = {
        allAccessEnabled: tuple.data?.allAccessEnabled ?? false
      };

      return {
        ...tuple,
        data
      };
    },
    [tuple]
  );
}



export function useToggleAllAccess() {
  const [fnMutate, tuple] = useToggleAllAccessMutation({
    refetchQueries: [
      {
        query: AppSettingsTabPaneDocument,
        variables: {}
      }
    ]
  });

  const fnWrappedMutate = React.useCallback(
    (enabled: boolean) => {
      fnMutate({
        variables: {
          enabled
        },
        optimisticResponse: {
          toggleAllAccess: enabled
        }
      });
    },
    [fnMutate]
  );

  return React.useMemo(
    () => [
      fnWrappedMutate,
      {
        ...tuple,
        data: null
      }
    ] as const,
    [
      fnWrappedMutate,
      tuple
    ]
  );
}
